import { Store, createStore, applyMiddleware, MiddlewareAPI, Dispatch } from 'redux';
import reduxThunk from 'redux-thunk';
import { compose, combineReducers } from 'redux';
import RootState from './state';

import messagesReducer from './messages/messages.reducer';
import appReducer from './app/app.reducer';

// import appMiddleware from './middleware/app'
import chatMiddleware from './middleware/chat';
import eventsMiddleware from './middleware/events'

const middlewares = [reduxThunk, chatMiddleware, eventsMiddleware];

export type MiddlewareStore = MiddlewareAPI<Dispatch, RootState>

export function configureStore(initialState?: RootState): Store<RootState> {
    const middleware = applyMiddleware(...middlewares);

    const rootReducer = combineReducers<RootState>({
        messages: messagesReducer as any,
        app: appReducer as any
    });

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    
    const store = createStore(
        rootReducer,
        initialState,
        composeEnhancers(middleware)
    ) as Store<RootState>;

    return store;
}
